import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useInternationalization } from '@progress/kendo-react-intl';
import { PIN_TRIGGER } from '../../../redux/types';
import { downloadDoc, removePin } from '../../../common/services/http/documentsService';
import Pin from '../button/pin/pin';

import './card.scss';

interface ICard {
  item?: any;
}

const Card: React.FC<ICard> = ({ item }) => {
  const dispatch = useDispatch();

  const intl = useInternationalization();

  const clickHandler = () => {
    removePin(item.assignId).then(() => {
      dispatch({ type: PIN_TRIGGER });
    });
  };

  return (
    <div className={'cardWrapper'}>
      <div className={'title'}>
        {item.fileType.toLowerCase() === 'pdf' ? (
          <Link to={`documents/pdf/${item.assignId}`}>
            <p className={'label'}> {item.label} </p>
          </Link>
        ) : (
          <span className={'pointer'} onClick={() => downloadDoc(item)}>
            <p className={'label'}> {item.label} </p>
          </span>
        )}
        <div className='card-pin-wrapper'>
          <p className={'cardDate'}>{intl.formatDate(new Date(item.date), 'd')}</p>
          <Pin clickHandler={clickHandler} isPinned={true} className={'pointer'} />
        </div>
      </div>
      <p className={'fundName'}>{item.fundName}</p>
      <p className={'investorName'}>{item.objectName}</p>
    </div>
  );
};

export default Card;
